import React from 'react';

import {getChatMessageMarkup, transformLinks, transformMentionMessage} from '@common/react/components/Chat/ChatUtils';
import {getFilesLayout} from '@common/react/components/Chat/ChatMessageList';
import {ChatComponents, ChatMessageListComponentsDictionary} from '@common/react/components/Chat/ChatSettingsProvider';
import {ChatMessage} from '@common/react/objects/Chat';
import {processLink} from '@common/react/components/UI/LinkPreview/LinkPreview';

interface RegularChatMessage {
	message: ChatMessage;
	onImageClick?: any;
	contacts: any[];
}

const RegularChatMessage: React.FC<RegularChatMessage> = ({message, onImageClick, contacts}) => {
	const [previewMatches, setPreviewMatches] = React.useState<string[]>([]);
	
	React.useEffect(() => {
		handleLinkProcess();
	}, [message, message.text]);
	
	const handleLinkProcess = React.useCallback(() => {
		const processResult = processLink(message.text);
		setPreviewMatches(processResult);
	}, [message, message.text]);
	
	return (
		<>
			<div
				className="chat-message-list-component__item-content"
				dangerouslySetInnerHTML={{__html: transformLinks(transformMentionMessage(getChatMessageMarkup(message.text), contacts, true))}}
			/>
			{previewMatches && ChatMessageListComponentsDictionary[ChatComponents.LinkPreviewGroup](previewMatches, `message-${message.id}`)}
			{message.files.length ? getFilesLayout(message.files, onImageClick) : null}
		</>
	);
};

export default RegularChatMessage;